// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o2-1";
export var messageSideRight = "_o2-2";
export var orderLookupBubbleContainer = "_o2-0";
export var submitButton = "_o2-3";